// extracted by css-extract-rspack-plugin
export default {"Text":"multi-select-editor-module__Text__zqR3Z"};